import { Usuario } from 'src/app/_core/models/usuario';
import { Localizacao } from 'src/app/_core/models/localizacao';
import { CadastroBemService } from 'src/app/_core/services/cadastro-bem.service';
import { DOCUMENT } from '@angular/common';
import { LocalizacaoService } from 'src/app/_core/services/localizacao.service';
import { LoginService } from 'src/app/_core/services/login.service';
import { Component, Inject, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CadastroBem } from 'src/app/_core/models/cadastro-bem';
import { GrupoService } from 'src/app/_core/services/grupo.service';
import { Movimentacao } from 'src/app/_core/models/movimentacao';

@Component({
  selector: 'app-grupo-alterar-cautela',
  templateUrl: './grupo-alterar-cautela.component.html',
  styleUrls: ['./grupo-alterar-cautela.component.scss']
})
export class GrupoAlterarCautelaComponent implements OnInit {
  form!:FormGroup;
  public cadastro:CadastroBem[];
  movimentacao:Movimentacao;
  public data:any[] = [];
  local:Localizacao;
  keywordMatriculaDest = 'nome';
  keywordUnidade='dS_BPM_UNIDADE';
  keywordMeusBens='dS_BPM_DESCRICAO_BEM';
  title = 'Tela de liberação';
  loading = true;
  user!: Usuario;
  usuario: Usuario;
  deletando: boolean = false;
  name: string = '';
  public localizacao:Localizacao[];

  constructor(
    private fb:FormBuilder,
    private cadastroBemService:CadastroBemService,
    private grupoService:GrupoService,
    private loginService:LoginService,
    private localizacaoService:LocalizacaoService,
    @Inject(DOCUMENT) private document: Document) {
      this.movimentacao = new Movimentacao();
      
     }

  ngOnInit(): void {
    this.loading = false;
    this.listarUser()
    this.movimentacao = new Movimentacao();
    this.gerarForm();
    this.listarLocalizacaoBensAll();
    this.loading = false;
    this.user = JSON.parse(localStorage.getItem('currentUser') || '{}');
    this.form.controls['cD_CDU_MATRICULA_ORIGEM'].setValue(JSON.stringify(this.user.cD_MATRICULA));
    this.form.controls['cD_CDU_MATRICULA_AUTOR'].setValue(this.user.cD_MATRICULA);
    this.name = JSON.stringify(this.user.nome);
    this.listarMeusBensById();
  }
  selectDest(item:any) {
    //console.log/item)
    const num = item.cD_MATRICULA
    this.form.get('cD_CDU_MATRICULA_DESTINO')?.setValue(num)
  }
  selectEvent(item:any) {
    //console.log/item)
    const num = item.cD_BPM_NR_UNIDADE
    this.form.get('cD_BPM_UNIDADE_OP_POSTERIOR')?.setValue(num)
  }
  selectMeusBens(item:any) {
    //console.log/item)
    const num = item.nR_BPM_BEM_PATRIMONIAL
    this.form.get('nR_BPM_BEM_PATRIMONIAL')?.setValue(num)
  }

  listarUser(){
    this.loginService.getAll()
    .subscribe(
      data=> {
        this.data = data;
        this.data.map( data => data.nome = ` ${data.cD_MATRICULA} | ${data.nome} `)
      }
    )
  }
  refresh() {
    this.document.location.reload();
  }
  gerarForm(){
    this.form = this.fb.group({
      nR_BPM_BEM_PATRIMONIAL:[null,[Validators.required]],
      cD_CDU_MATRICULA_ORIGEM:[null,[]] ,
      cD_BPM_UNIDADE_OP_POSTERIOR:['',[]],
      cD_CDU_MATRICULA_DESTINO:[null,[]],
      dS_BPM_SALA_POSTERIOR:[null,[]],
      fL_BPM_DELETADO:[0,[]],
      cD_CDU_MATRICULA_AUTOR:[null,[]]
    })
  }
  // listarBensAll(){
  //   this.cadastroBemService.listarBensAll().subscribe(
  //     data => {
  //       this.cadastroBem = data;
        
  //     }
  //   )
  // }
  listarMeusBensById(){
    this.cadastroBemService.listarMatById(this.user.cD_MATRICULA)
    .subscribe(
      data => {
               this.cadastro = data;
               this.cadastro.map( data => data.dS_BPM_DESCRICAO_BEM = ` ${data.nR_BPM_BEM_PATRIMONIAL} | ${data.dS_BPM_DESCRICAO_BEM}`);
             }
    )
  }
  listarLocalizacaoBensAll() {
    this.localizacaoService.localizacaoAll()
      .subscribe(
        data => {
          this.localizacao = data;
          this.local = data;
        }
      )
  }
  
  submit() {
    this.loading = true;
    if(this.form.invalid){
      Swal.fire('Alerta','Olá digite os campos corretamente','warning');
      return;
    }
    this.form.get('cD_CDU_MATRICULA_ORIGEM')?.setValue(
      Number(this.form.controls['cD_CDU_MATRICULA_ORIGEM'].value));
    this.form.get('nR_BPM_BEM_PATRIMONIAL')?.setValue(
        Number(this.form.controls['nR_BPM_BEM_PATRIMONIAL'].value));
    // this.form.get('cD_CDU_MATRICULA_DESTINO')?.setValue(
    //   Number(this.form.controls['cD_CDU_MATRICULA_DESTINO'].value));
    if(this.form.controls['cD_BPM_UNIDADE_OP_POSTERIOR'].value == ''){
      this.form.controls['cD_BPM_UNIDADE_OP_POSTERIOR']?.setValue(0) 
     }

    var movimentacao:Movimentacao = this.form.value;

   if(movimentacao.cD_CDU_MATRICULA_DESTINO == null){
    movimentacao.cD_CDU_MATRICULA_DESTINO = 0
   }
   
     //console.log/movimentacao);

    this.grupoService.insertAlterarCautelaGrupo(movimentacao)
    .subscribe(
      data => {
        Swal.fire(
          'Sucesso!',
          'Operação Realizada!',
          'success'
        ).then(() => {
          this.loading = false;
          
        });
      },
      err =>{
        this.loading = false;
        
      }
    )
  }
  
}
